/* Publish by EComposer at 2026-09-29 14:30:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1xp5ya2jmzo"]=  window.__ectimmers["ecom-1xp5ya2jmzo"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1xp5ya2jmzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xp5ya2jmzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6ifz7bg0qf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6ifz7bg0qf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0kiniy2ok7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0kiniy2ok7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y626wuixla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y626wuixla', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfufbv38d9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfufbv38d9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-waxg1sbsprn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-waxg1sbsprn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-us6r1204sz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-us6r1204sz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6b4qygq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6b4qygq7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ecukevsrxjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ecukevsrxjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwctyj0y8x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwctyj0y8x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozp0xp0dta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozp0xp0dta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1feq1jsxpjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1feq1jsxpjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xsncz1yeuce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xsncz1yeuce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3m53oba7zo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3m53oba7zo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e94a18mq024').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e94a18mq024', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s1k9557s9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s1k9557s9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xa9ldtohtkq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xa9ldtohtkq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7iujquz2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7iujquz2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eqvkjsm5tdv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eqvkjsm5tdv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa65ejxnn58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa65ejxnn58', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nzek43vuzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nzek43vuzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1sy2051czuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1sy2051czuj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mu2qnfmt6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mu2qnfmt6f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-241rq015jh4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-241rq015jh4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7eyjtpuuzv4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7eyjtpuuzv4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5mfm9w4e3qo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5mfm9w4e3qo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vzl0lfi6rgc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vzl0lfi6rgc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oiusl0lt2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oiusl0lt2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h33zwbgedro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h33zwbgedro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4ofvxhfpo7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4ofvxhfpo7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ajpu3l2ztn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ajpu3l2ztn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5z9yj9n3pyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5z9yj9n3pyd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzb6kink29p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzb6kink29p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53neq0opz2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53neq0opz2s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1q5nrj9zgwi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1q5nrj9zgwi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vfsd3ew609').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vfsd3ew609', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57jptft7chm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57jptft7chm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6q1wupai575').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6q1wupai575', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1ycvfkfopm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1ycvfkfopm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9larpdb8aw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9larpdb8aw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7lki0u9jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7lki0u9jp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v0j82if6zd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v0j82if6zd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8n8471t85t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8n8471t85t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6b41upmcdzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6b41upmcdzp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjk2vwynnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjk2vwynnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khp492cnm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khp492cnm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jlatoge8abs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jlatoge8abs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9r746f6x9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9r746f6x9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mdrgnlvk6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mdrgnlvk6i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-st1yw5e9kjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-st1yw5e9kjb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwtvryozoz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwtvryozoz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icl7k4j8h4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icl7k4j8h4c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57zeajr75sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57zeajr75sj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-onjrc2n5y5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onjrc2n5y5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yz4bsfwhn4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yz4bsfwhn4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4h9uvrn2xq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4h9uvrn2xq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn5r38h83i9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn5r38h83i9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tb4iuj54yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tb4iuj54yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2zdituewxuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2zdituewxuk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0fhzktq3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0fhzktq3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ayt6qs6utw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ayt6qs6utw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e1h3ojzicq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e1h3ojzicq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v76dpx3jy8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v76dpx3jy8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtow79oogis').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtow79oogis', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0p988l63rr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0p988l63rr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k6d5fbq3jzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k6d5fbq3jzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nizysisxqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nizysisxqe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-czw1pryd7tt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-czw1pryd7tt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-01hoyfelvnfy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01hoyfelvnfy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfea094zcpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfea094zcpd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhujaa9kqrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhujaa9kqrh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5x0nmmxzuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5x0nmmxzuf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr2yptqcsde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr2yptqcsde', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aw1k60q2rqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw1k60q2rqo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwo3j3j3moo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwo3j3j3moo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5quecmi8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5quecmi8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3qr1cdg4mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3qr1cdg4mf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2v863xc1767').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2v863xc1767', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vukf67ttx8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vukf67ttx8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmx8vrlk7ya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmx8vrlk7ya', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwtog4589gi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwtog4589gi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oi8knx3ljxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oi8knx3ljxh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvzwdrl1qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvzwdrl1qb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccl5368fhei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccl5368fhei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvjhyp05lua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvjhyp05lua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-938fmoba0eq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-938fmoba0eq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ua5hz0qj7l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ua5hz0qj7l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxfg5gk0snp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxfg5gk0snp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ggeycrpbbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ggeycrpbbj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0bfn4jkpfpx7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0bfn4jkpfpx7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mfgr18p1jnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mfgr18p1jnb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jx2bnrwkqtk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jx2bnrwkqtk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sswmgp11vom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sswmgp11vom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-187174kq34q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-187174kq34q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iirvi60fa8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iirvi60fa8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ehx9t6hor6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ehx9t6hor6', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ccukimqecpm"]=  window.__ectimmers["ecom-ccukimqecpm"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-ccukimqecpm"]["prl2fj90g"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ccukimqecpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccukimqecpm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1mw50aaaxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1mw50aaaxf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9bphsi6wypt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9bphsi6wypt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0oc8sjis0e58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0oc8sjis0e58', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-so9y5wt9zbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-so9y5wt9zbr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgyihy3ma15').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgyihy3ma15', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mu4hiifq1lb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mu4hiifq1lb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10goozvztnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10goozvztnf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21kifw2eobb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21kifw2eobb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8uelhens2iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8uelhens2iq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jp360pjojy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jp360pjojy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rm3etyn2mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rm3etyn2mh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9dvitvz7rqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9dvitvz7rqo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pb4gtbnbbcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pb4gtbnbbcr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7fqww2bylj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7fqww2bylj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-de73y30uhph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-de73y30uhph', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j09pwcz4k3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j09pwcz4k3i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qty737tcz1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qty737tcz1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8uucl8r60m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8uucl8r60m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3u84yvw389').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3u84yvw389', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwautrh5zx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwautrh5zx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loaold1z8ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loaold1z8ob', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lcgwrih2it').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lcgwrih2it', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ok45ff5d4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ok45ff5d4w', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrh0ptoe4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrh0ptoe4q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f3dz64frnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f3dz64frnj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e36g41dmi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e36g41dmi8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpb5exy3ot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpb5exy3ot', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5m1d51hcey2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5m1d51hcey2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqwvy3h0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqwvy3h0a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xr4p3vk4lm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xr4p3vk4lm8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5tqiliqm8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5tqiliqm8t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0jhljyxv1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0jhljyxv1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14l1hco8615').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14l1hco8615', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwuatqdyf5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwuatqdyf5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fht4auzhmb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fht4auzhmb9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j17qh6jwd7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j17qh6jwd7s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jo9pebac23').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jo9pebac23', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60o30mdwhqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60o30mdwhqd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm9icadejbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm9icadejbk', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2vyaxhsk8x4"]=  window.__ectimmers["ecom-2vyaxhsk8x4"] || {};
var E,C,I,A,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=(C=this.settings.disable_auto_close__tablet)!=null?C:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(A=this.settings.scroll_on_mobile)!=null?A:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function W(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(W)}window.requestAnimationFrame(W)}function k(L){w(v(L)-100)}function $(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const W=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||W)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}$(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>$(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-2vyaxhsk8x4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vyaxhsk8x4', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ze2ie4mlcy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ze2ie4mlcy', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qyzul7uolkc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qyzul7uolkc', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lg6q14bm5sq"]=  window.__ectimmers["ecom-lg6q14bm5sq"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-lg6q14bm5sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lg6q14bm5sq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1muaz2md3a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1muaz2md3a', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-88c1jcyfzi4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-88c1jcyfzi4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53zwyrozo4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53zwyrozo4l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79k9jns0hgy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79k9jns0hgy', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z207cjtks6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z207cjtks6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vejnvemfioc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vejnvemfioc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pynebgast').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pynebgast', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6jzt7b1dm1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6jzt7b1dm1r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uckx6zv20kb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uckx6zv20kb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ch54fd4wprn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ch54fd4wprn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w26jj5sr5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w26jj5sr5g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wiicwmorexk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wiicwmorexk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1h1zwo596p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1h1zwo596p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u86bpgb5ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u86bpgb5ma', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pqnudguvli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pqnudguvli', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nogkgzm2oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nogkgzm2oo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cytxvn0wqzw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cytxvn0wqzw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3cw8snr8axn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3cw8snr8axn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0l8cthm951tk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0l8cthm951tk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvnaqg19d8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvnaqg19d8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}